// Contenu du module "Logique des classes" – pédagogie sur la numérotation PCG
export const LOGIQUE_SECTIONS = [
  {
    titre: "Le principe fondateur : la partie double",
    contenu:
      "Toute opération comptable s'enregistre par au moins deux écritures, l'une au débit, l'autre au crédit, pour des montants strictement égaux. C'est la règle d'or : sans elle, le bilan ne s'équilibre pas. Le PCG est conçu pour rendre cette logique automatique : à chaque classe correspond une fonction économique.",
  },
  {
    titre: "Pourquoi 8 classes ? La structure du bilan et du résultat",
    contenu:
      "Les classes 1 à 5 forment le bilan (ce que possède et doit l'entreprise à un instant T). Les classes 6 et 7 forment le compte de résultat (ce qui se consomme et se produit pendant l'exercice). La classe 8 regroupe les comptes spéciaux et hors bilan. C'est l'architecture économique de l'entreprise traduite en numérotation.",
  },
  {
    titre: "Classes 1 et 2 : Le haut du bilan – ressources et emplois durables",
    contenu:
      "Classe 1 = ressources durables (capital, réserves, emprunts) : c'est ce qui finance l'entreprise sur le long terme. Classe 2 = emplois durables (immobilisations) : c'est ce dans quoi l'argent a été investi. Le haut du bilan répond à la question : \"Comment finance-t-on quoi ?\"",
  },
  {
    titre: "Classes 3, 4, 5 : Le bas du bilan – le cycle d'exploitation",
    contenu:
      "Classe 3 = stocks. Classe 4 = créances et dettes d'exploitation (clients, fournisseurs, État, personnel). Classe 5 = trésorerie. Ces trois classes décrivent le cycle court : on achète (4 fournisseurs), on stocke (3), on vend (4 clients), on encaisse (5 banque). En boucle.",
  },
  {
    titre: "Classes 6 et 7 : Le compte de résultat – consommation et production",
    contenu:
      "Classe 6 = charges (ce qui appauvrit l'entreprise, toujours débité). Classe 7 = produits (ce qui l'enrichit, toujours crédité). Résultat = 7 – 6. Si 7 > 6, bénéfice. Si 6 > 7, perte. Astuce : 6 + 1 = 7 → \"on dépense d'abord (6), on gagne ensuite (7)\".",
  },
  {
    titre: "Le parallélisme des sous-classes : 28 ↔ 2, 29 ↔ 2, 39 ↔ 3, 49 ↔ 4, 59 ↔ 5",
    contenu:
      "Le PCG répète une logique : à chaque classe d'actif correspondent les comptes correctifs en 8 (amortissements) et 9 (dépréciations). Exemple : 215 \"Installations techniques\" se déprécie via 2815 \"Amortissements des installations techniques\". 411 \"Clients\" est déprécié par 491 \"Dépréciation des comptes de clients\". Idem pour 39 (dépréciation stocks), 59 (dépréciation VMP). Cette répétition est volontaire : elle permet de retrouver le compte correctif sans réfléchir.",
  },
  {
    titre: "Le parallélisme 6/7 : 661 ↔ 761, 657 ↔ 757, 681 ↔ 781",
    contenu:
      "Les charges et produits sont organisés en miroir : 66 charges financières / 76 produits financiers ; 67 charges exceptionnelles / 77 produits exceptionnels ; 68 dotations / 78 reprises sur dotations. Si vous trouvez la charge, vous trouvez le produit symétrique en remplaçant le 6 par 7.",
  },
  {
    titre: "Le 8 final : un repère universel pour \"autres\"",
    contenu:
      "Dans presque toutes les classes, le chiffre 8 en fin de numéro désigne \"autres\" ou \"divers\". Exemples : 6068 \"Autres matières et fournitures\", 7088 \"Autres produits d'activités annexes\", 4458 \"TVA à régulariser ou en attente\". Quand vous ne savez pas où classer, regardez s'il existe un \"…8\" dans la sous-classe.",
  },
  {
    titre: "Lire un numéro PCG comme une adresse postale",
    contenu:
      "Le premier chiffre indique la classe (le \"pays\"), le deuxième la division (la \"région\"), le troisième la subdivision (la \"ville\"), les chiffres suivants affinent (la \"rue\" puis le \"numéro\"). Exemple : 44566 → 4 (tiers) → 44 (État) → 445 (État – taxes sur le CA) → 4456 (TVA déductible) → 44566 (TVA déductible sur ABS). Ce découpage est universel : plus c'est long, plus c'est précis.",
  },
];
